import {v4 as uuidv4} from 'uuid';
import {FailedRecord} from "../storyblocks/common/FailedRecord";
import {Meta} from "../storyblocks/common/Meta";
import {TraceContext} from "../storyblocks/common/TraceContext";
import {Origin} from "../storyblocks/OriginEnum";
import { BaseAvroRecord } from '../BaseAvroRecord';

export class EventFactory {
    public static meta(origin: Origin, trace?: TraceContext): Meta {
        const meta = new Meta;
        meta.uuid = uuidv4();
        meta.emitted = Date.now();
        meta.origin = origin;
        meta.trace = trace;
        return meta;
    }

    public static failedRecord(record: BaseAvroRecord, topic: string, origin: Origin, details?: string, trace?: TraceContext): FailedRecord {
        const failedRecord = new FailedRecord();
        failedRecord.meta = EventFactory.meta(origin, trace);
        failedRecord.payload = JSON.stringify(record);
        failedRecord.topic = topic;
        if (details) failedRecord.details = details;
        return failedRecord;
    }
}
